// To exclude weekends and holidays 
$(document).ready(function() {
    $('.contact-date-form').on('change', function() {
        const selectedDate = new Date($(this).val());
        const dayOfWeek = selectedDate.getDay(); 
        const formattedDate = formatDate(selectedDate);
        const holidays = ['2024-04-10', '2024-04-11']; // Raya dates

        // Weekend check
        if (dayOfWeek === 0 || dayOfWeek === 6) {
            alert('Please select a date that is not a weekend (Saturday or Sunday).');
            $(this).val(''); 
        }

        // Raya holiday check
        if (holidays.includes(formattedDate)) {
            alert('Please select a date that is not a holiday.');
            $(this).val(''); 
        }
    });

    function formatDate(date) {
        const year = date.getFullYear();
        let month = (date.getMonth() + 1).toString().padStart(2, '0');
        let day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
});